export default "__VITE_PUBLIC_ASSET__f0184918__"